import { render } from "./ForgetPasswordForm.vue?vue&type=template&id=222467b4&scoped=true"
import script from "./ForgetPasswordForm.vue?vue&type=script&lang=js"
export * from "./ForgetPasswordForm.vue?vue&type=script&lang=js"

import "./ForgetPasswordForm.vue?vue&type=style&index=0&id=222467b4&scoped=true&lang=css"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-222467b4"],['__file',"src/components/LoginFlow/ForgetPasswordForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "222467b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('222467b4', __exports__)) {
    console.log('reload')
    api.reload('222467b4', __exports__)
  }
  
  module.hot.accept("./ForgetPasswordForm.vue?vue&type=template&id=222467b4&scoped=true", () => {
    console.log('re-render')
    api.rerender('222467b4', render)
  })

}


export default __exports__